import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Component from './component'
import { openModal } from '../../redux/modules/wertermittler'

const WithData = connect(
  () => ({}),
  dispatch => bindActionCreators({ openModal }, dispatch)
)(Component)

export default WithData
